import quickMessageApi from '../api/quickMessageApi';
import QuickMessage from '../models/quickMessage';
import quickMessageModel from '../models/quickMessage';
import { IApiResponse } from 'redhotpie-shared-lib/interfaces/IApiResponse';

class QuickMessageService {
  loadAll(): Promise<IApiResponse> {
    return quickMessageApi.loadAll().then(res => {
      try {
        if (res.success && res.data && res.data.items) {
          res.data.items = quickMessageModel.mappingObjects(res.data.items);
        } else {
          console.log('ERROR: quickMessageService/loadAll:', res.message);
        }
        return res;
      } catch (e) {
        console.log('ERROR: quickMessageService/loadAll', e);
        throw new Error('failed');
      }
    });
  }

  updateQuickMessage(params: QuickMessage): Promise<IApiResponse> {
    const _params = quickMessageModel.revertMappingObject(params);
    return quickMessageApi.updateQuickMessage(_params).then(res => {
      try {
        if (res.success) {
          res.data = quickMessageModel.mappingObject(res.data);
        } else {
          console.log('ERROR: quickMessageService/updateQuickMessage:', res.message);
        }
        return res;
      } catch (e) {
        console.log('ERROR: quickMessageService/updateQuickMessage', e);
        throw new Error('failed');
      }
    });
  }

  addQuickMessage(params: QuickMessage): Promise<IApiResponse> {
    const _params = quickMessageModel.revertMappingObject(params);
    return quickMessageApi.addQuickMessage(_params).then(res => {
      try {
        if (res.success) {
          // let responseData = quickMessage.mappingObject(res.data);
          res.data = quickMessageModel.mappingObject(res.data);
        } else {
          console.log('ERROR: quickMessageService/addQuickMessage:', res.message);
        }
        return res;
      } catch (e) {
        console.log('ERROR: quickMessageService/addQuickMessage', e);
        throw new Error('failed');
      }
    });
  }

  deleteQuickMessage(params: Pick<QuickMessage, 'templateId'>): Promise<IApiResponse> {
    const templateIDs = { TemplateIDs: [params.templateId] };

    return quickMessageApi.deleteQuickMessage(templateIDs).then(res => {
      try {
        if (res.success) {
          // let responseData = quickMessage.mappingObject(res.data);
          res.data = params;
        } else {
          console.log('ERROR: quickMessageService/deleteQuickMessage:', res.message);
        }
        return res;
      } catch (e) {
        console.log('ERROR: quickMessageService/deleteQuickMessage', e);
        throw new Error('failed');
      }
    });
  }
}

export default new QuickMessageService();
